<template>
  <v-row class="mx-0">

    <v-col :md="vShowCalendar ? 4 : 12" class="py-0">

      <v-row>
        <v-col :md="vShowCalendar ? 12 : 8">
          <v-row class="custom-grey-border">
            <v-col md="12" class="light-gray-background custom-border-bottom d-flex justify-space-between">
              <div style="font-size: 19px" class="text-uppercase font-weight-700 color-custom-blue">
                Schedule
              </div>
              <div>
                <!-- <v-btn class="mx-2 custom-bold-button white--text" color="cyan" right small :disabled="jobLoading"
                  depressed v-on:click="updateCalendar()">
                  <v-icon small class="mr-2">mdi-calendar-blank</v-icon>
                  <span v-if="vShowCalendar">Hide Calendar</span>
                  <span v-else>Show Calendar</span> 
                </v-btn> -->
              </div>
            </v-col>
            <v-col :md="vShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-start-date">Start Date</label>
              <DatePicker :disabled="jobLoading" key="visit-one-off-start-date" id="visit-one-off-start-date"
                :allowed-dates="allowedDates" placeholder=" Start Date" :value="oneOffSchedule.start_date" v-on:change="
                  updateScheduleState('dbOneOffSchedule.start_date', $event);
                updateScheduleState('dbOneOffSchedule.end_date', $event);
                getBusinessHours();
                " />
            </v-col>
            <v-col :md="vShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-start-time">Start Time</label>
              <TimePicker :disabled="jobLoadingData" key="visit-one-off-start-time" id="visit-one-off-start-time"
                placeholder="Start Time" v-model="oneOffSchedule.start_time" :minTime="min_start_time"
                :maxTime="end_time" type="start-time" v-on:change="
                  updateScheduleState('dbOneOffSchedule.start_time', $event)
                  " />
              <!--  <TimePicker
                :disabled="jobLoading"
                key="visit-one-off-start-time"
                id="visit-one-off-start-time"
                placeholder="Start Time"
                v-model="oneOffSchedule.start_time"
                :min-time="todayTime"
                v-on:change="
                  updateScheduleState(
                    'dbOneOffSchedule.start_time',
                    $event
                  ) 
                "
                type="start-time"
              /> -->
            </v-col>
            <v-col :md="vShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-end-time">End Time</label>
              <!-- <TimePicker
                :disabled="jobLoading"
                key="visit-one-off-end-time"
                id="visit-one-off-end-time"
                placeholder="End Time"
                v-model="oneOffSchedule.end_time"
                :min-time="updatedDate"
                v-on:change="
                  updateScheduleState('dbOneOffSchedule.end_time', $event)
                "
              /> -->
              <TimePicker :disabled="jobLoadingData" key="visit-one-off-end-time" id="visit-one-off-end-time"
                placeholder="End Time" :min-time="oneOffSchedule.start_time" v-model="oneOffSchedule.end_time"
                :maxTime="end_time" type="end-time" v-on:change="
                  updateScheduleState('dbOneOffSchedule.end_time', $event)
                  " />
            </v-col>
            <v-col md="12">
              <p class="m-0 p-4 font-size-16 font-weight-500 light-gray-background custom-grey-border">
                This job will start on
                {{ formatDate(oneOffSchedule.start_date) }}
                {{ oneOffSchedule.start_time }} and finish on
                {{ formatDate(oneOffSchedule.end_date) }}
                {{ oneOffSchedule.end_time }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col :md="vShowCalendar ? 12 : 4">
          <ScheduleTeam :key="`job-one-off-schedule-team-${scheduleKey}`" />
        </v-col>
      </v-row>
    </v-col>
    <v-col v-if="vShowCalendar" md="8">
      <Calendar :key="`job-one-off-calendar-${scheduleKey}`" :show-calendar="vShowCalendar"></Calendar>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import ScheduleTeam from "@/view/components/main-job/ScheduleTeam.vue";
import DatePicker from "@/view/components/main-job/QDatePicker.vue";
import TimePicker from "@/view/components/main-job/TimePicker.vue";
import Calendar from "@/view/pages/partials/Calendar.vue";
import {
  UPDATE_DEFAULT_DATE,
  UPDATE_CALENDAR_ACTION,
  UPDATE_SCHEDULE_STATE,
  RESET_ENGINEER,
} from "@/core/services/store/job.module";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "job-ctx-one-off-schedule",
  data() {
    return {
      todayDate: moment(new Date()).format("YYYY-MM-DD"),
      scheduleKey: Number(new Date()),
      min_start_time: null,
      end_time: null,
      jobLoadingData: false,
    };
  },
  props: {
    business_hours: {
      type: Object,
      default: () => ({}),
    }, holidays: {
      type: Object,
      default: () => ({}),

    },
  },
  methods: {
    allowedDates(val) {
      return !this.holidays.some(day => day.date === val);
    },
    convertTo24Hour(time) {
      const [timePart, modifier] = time.split(' ');
      let [hours, minutes] = timePart.split(':').map(Number);

      if (modifier === 'PM' && hours !== 12) {
        hours += 12;
      }
      if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }

      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    },
    getBusinessHours() {
      const dayName = new Date(this.oneOffSchedule.start_date).toLocaleDateString('en-US', { weekday: 'long' });
      const dayData = this.business_hours.find(day => day.title === dayName);
      if (dayData && dayData.status) {
        const start = this.convertTo24Hour(dayData.start_time);
        const end = this.convertTo24Hour(dayData.end_time);
        if (!this.$route.query?.ticket || !this.$route.query?.visit) {
          this.oneOffSchedule.start_time = dayData.start_time;
          this.oneOffSchedule.end_time = this.addMinutes(start, 15);
        }
        // const start = this.convertTo24Hour(dayData.start_time);
        // const end = this.convertTo24Hour(dayData.end_time);
        this.min_start_time = this.subtractMinutes(start, 15);
        this.end_time = this.addMinutes(end, 15);
        this.jobLoadingData = false;
        return;
      }
      else {
        this.jobLoadingData = true;
      }
    },
    addMinutes(time, minutes) {
      const [hours, mins] = time.split(':').map(Number);

      const date = new Date();
      date.setHours(hours);
      date.setMinutes(mins + minutes);

      let h = date.getHours();
      const m = String(date.getMinutes()).padStart(2, '0');

      const ampm = h >= 12 ? 'PM' : 'AM';

      // convert to 12-hour format
      h = h % 12;
      h = h ? h : 12; // 0 should be 12

      h = String(h).padStart(2, '0');

      return `${h}:${m} ${ampm}`;
    },

    subtractMinutes(time, minutes) {
      return this.addMinutes(time, -minutes);
    },

    roundTo15Min(time) {
      const [h, m] = time.split(':').map(Number);
      const total = h * 60 + m;
      const rounded = Math.ceil(total / 15) * 15;

      const hh = String(Math.floor(rounded / 60)).padStart(2, '0');
      const mm = String(rounded % 60).padStart(2, '0');

      return `${hh}:${mm}`;
    },
    formatDate(date) {
      if (moment(date).isValid()) {
        return moment(date).format("DD MMMM YYYY");
      }
    },
    updateScheduleState(key, value) {
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
      this.$store.commit(RESET_ENGINEER);
      this.updateDefaultDate();
    },
    updateDefaultDate() {
      this.$nextTick(() => {
        this.$store.dispatch(UPDATE_DEFAULT_DATE, "one-off");
      });

    },
    updateCalendar() {
      this.$store.commit(UPDATE_CALENDAR_ACTION);
    },
  },
  mounted() {
    this.updateDefaultDate();
  },
  created() {
    this.getBusinessHours();

    // this.updateScheduleState('dbOneOffSchedule.start_time', null);
    // this.oneOffSchedule.start_time = null;
    // this.oneOffSchedule.end_time = null;
    // this.updateScheduleState('dbOneOffSchedule.end_time', null);

  },
  components: {
    ScheduleTeam,
    Calendar,
    TimePicker,
    DatePicker,
  },
  computed: {
    ...mapGetters(["vShowCalendar", "oneOffSchedule", "jobLoading"]),
    /*  todayTime() {
      return moment(this.oneOffSchedule.start_date).format("hh:mm A");
    }, */
    /* updatedDate() {
      return moment(this.oneOffSchedule.start_time, "hh:mm A")
        .add(60, "minutes")
        .format("hh:mm A");
    }, */
  },
  watch: {
    oneOffSchedule: {
      handler(val) {
        if (!val?.start_date || !val?.start_time) return;
        if (this.$route.query?.ticket || this.$route.query?.ticket) {
          return;
        }
        const dayName = new Date(val.start_date).toLocaleDateString('en-US', {
          weekday: 'long',
          timeZone: 'Asia/Singapore'
        });

        const dayData = this.business_hours.find(
          day => day.title === dayName
        );

        if (dayData && dayData.status) {
          const starttime = this.convertTo24Hour(dayData.start_time);
          const endTime = this.convertTo24Hour(dayData.end_time);
          this.min_start_time = this.subtractMinutes(starttime, 15);
          this.end_time = this.addMinutes(endTime, 15);
          this.jobLoadingData = false;

          const toMinutes = (time) => {
            if (!time) return null;

            // 24-hour format
            if (!time.includes(' ')) {
              const [h, m] = time.split(':').map(Number);
              return h * 60 + m;
            }

            const [hourMin, modifier] = time.split(' ');
            let [hours, minutes] = hourMin.split(':').map(Number);

            if (modifier === 'PM' && hours !== 12) hours += 12;
            if (modifier === 'AM' && hours === 12) hours = 0;

            return hours * 60 + minutes;
          };
          const start = toMinutes(val.start_time);
          const end = val.end_time ? toMinutes(val.end_time) : null;
          const min = toMinutes(dayData.start_time);
          const max = toMinutes(dayData.end_time);

          if (start < min || start > max) {
            this.oneOffSchedule.start_time = null;
          }
          if (end !== null) {
            if (end > max || end <= start) {
              this.oneOffSchedule.end_time = null;
            }
          }
        } else {
          this.jobLoadingData = true;
          this.oneOffSchedule.start_time = null;
          this.oneOffSchedule.end_time = null;
        }
      },
      deep: true
    }
  }
};
</script>
